import { Tag, Input, Tooltip, Icon } from 'antd';
import React, { PureComponent } from 'react';

export class PurposeStatePresetGroup extends PureComponent {
  constructor(props) {
    super(props);
    const value = props.value || [];
    this.state = {
      purposeStatePresets: value,
      inputVisible: false,
      inputValue: '',
      validationError: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { value } = nextProps;
    this.setState({ purposeStatePresets: value });
  }


  handleClose = removedTag => {
    const purposeStatePresets = this.state.purposeStatePresets.filter(tag => tag !== removedTag);
    this.setState({ purposeStatePresets });
    const { onChange } = this.props;
    if (onChange) {
      // This will provide the form with changes
      onChange(purposeStatePresets);
    }
  };

  showInput = () => {
    this.setState({ inputVisible: true }, () => this.input.focus());
  };

  handleInputChange = e => {
    this.setState({ inputValue: e.target.value, validationError: null });
  };

  handleInputConfirm = () => {
    let { inputValue } = this.state;

    if (inputValue && !['NSW', 'QLD', 'NT', 'SA', 'ACT', 'WA', 'TAS', 'VIC'].includes(inputValue.toUpperCase())) {
      this.setState({ validationError: 'Invalid state, valid states are NSW, QLD, NT, SA, ACT, WA, TAS, VIC' });
      return;
    }

    inputValue = inputValue.toUpperCase();

    let { purposeStatePresets } = this.state;
    if (inputValue && purposeStatePresets.indexOf(inputValue) === -1) {
      purposeStatePresets = [...purposeStatePresets, inputValue];
    }
    this.setState({
      purposeStatePresets,
      inputVisible: false,
      inputValue: '',
      validationError: null,
    });
    const { onChange } = this.props;
    if (onChange) {
      // This will provide the form with changes
      onChange(purposeStatePresets);
    }
  };

  saveInputRef = input => (this.input = input); // eslint-disable-line no-return-assign


  render() {
    const { purposeStatePresets, inputVisible, inputValue } = this.state;
    return (
      <div style={{ maxWidth: '550px' }}>
        {purposeStatePresets.map((tag, index) => {
          const isLongTag = tag.length > 20;
          const tagElem = (
            <Tag key={tag} closable={true} onClose={() => this.handleClose(tag)}>
              {isLongTag ? `${tag.slice(0, 20)}...` : tag}
            </Tag>
          );
          return isLongTag ? (
            <Tooltip title={tag} key={tag}>
              {tagElem}
            </Tooltip>
          ) : (
            tagElem
          );
        })}
        {inputVisible && (
          <Input
            ref={this.saveInputRef}
            type="text"
            size="small"
            style={{ width: 78 }}
            value={inputValue}
            onChange={this.handleInputChange}
            onBlur={this.handleInputConfirm}
            onPressEnter={this.handleInputConfirm}
          />
        )}
        {this.state.validationError && <div style={{ color: 'red' }}>{this.state.validationError}</div>}
        {!inputVisible && (
          <Tag onClick={this.showInput} style={{ background: '#fff', borderStyle: 'dashed' }}>
            <Icon type="plus" /> New State
          </Tag>
        )}
      </div>
    );
  }
}
